import { Outlet } from 'react-router-dom';
import { Header } from '@/features/header';
import { Sidebar } from '@/features/sidebar';
import { useContext } from 'react';
import { PageLoadingContext } from '@/state/contexts.ts';
import HeartLoader from '@/shared/ui/HeartLoader';
import { SubSideBar } from '@/features/sub-sidebar';
import { SubHeader } from '@/features/sub-header';
import {
  CopilotProvider,
  CopilotWidget,
  GlobalEffectBridges,
} from '@/features/copilot';
import { LayoutSlotsProvider, useLayoutSlots } from './LayoutSlotsContext';
import styles from './Layout.module.css';

function LayoutContent() {
  const { isPageLoading } = useContext(PageLoadingContext);
  const {
    setSidebarPortalEl,
    setHeaderPortalEl,
    sidebarActive,
    headerActive,
    headerTitle,
  } = useLayoutSlots();

  const isLoading = isPageLoading;

  return (
    <div className={styles.appLayout}>
      <Header />
      <div className={styles.bodyArea}>
        <Sidebar />
        <main className={styles.content}>
          {isLoading && (
            <div className={styles.loadingOverlay}>
              <HeartLoader showText />
            </div>
          )}
          <div className={styles.outletWrapper} data-loading={isLoading}>
            {sidebarActive && (
              <SubSideBar>
                <div ref={setSidebarPortalEl} />
              </SubSideBar>
            )}
            <div className={styles.outletContent}>
              {headerActive && (
                <SubHeader title={headerTitle}>
                  <div
                    ref={setHeaderPortalEl}
                    className={styles.portalTarget}
                  />
                </SubHeader>
              )}
              <div className={styles.pageContent}>
                <Outlet />
              </div>
            </div>
          </div>
        </main>
        <CopilotWidget />
      </div>
    </div>
  );
}

const Layout = () => (
  <CopilotProvider>
    <LayoutSlotsProvider>
      <LayoutContent />
      <GlobalEffectBridges />
    </LayoutSlotsProvider>
  </CopilotProvider>
);

export default Layout;
export { LayoutPageTitle } from './LayoutSlots';
